import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import DoingService from "./doingService";
import FinsiehedService from "./finishedService";
import { useMediaQuery } from 'react-responsive'
import Storages from "../../helper/storages";

import CanceledService from "./canceledService";
import {
  Picker,
  format,
  newDate,
  getCurrentYear,
  currentDateObject,
} from "@persian-tools/persian-mobile-datepicker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DatePicker from "react-multi-date-picker"


function TrackingService(props) {
  var [screenHight, setScreenHight] = useState(window.innerHeight);
  const [showPicker, setShowPicker] = useState(false);
  const [pickerName, setDatePickerName] = useState(false);

  const config = {
    year: {
      caption: {
        text: "سال",
      },
    },
    month: {
      caption: {
        text: "ماه",
      },
    },
    day: {
      caption: {
        text: "روز",
      },
    },
  };
  var [state, setState] = useState({
    startDate: new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 90)),
    endDate: new Date(),
    refresh: false
  })
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const minDate = newDate({
    year: getCurrentYear() - 10,
    month: currentDateObject().month,
    day: 1,
  });
  const maxDate = newDate({
    year: getCurrentYear() + 1,
    month: currentDateObject().month,
    day: 31,
  });


  let time = Storages.getRefreshTime()

  useEffect(() => {
    setScreenHight((window.innerHeight / 10) * 7.5);
  }, [window.innerHeight]);


  useEffect(() => {
    setState(prevState => ({
      ...prevState
      , refresh: !state?.refresh
    }))
  }, [props.refresh])

  useEffect(() => {
    setInterval(() => {
      setState(prevState => ({
        ...prevState
        , refresh: !state?.refresh
      }))
    }, time);
  }, [])

  return (
    <div className="p-3">
      <div className="d-flex justify-content-start align-items-center my-3">


        {
          props.showFilter ?

            <div className=" d-flex flex-row align-items-center ">

              <lable className="px-2">
                از
              </lable>

              <div className="ps-1 d-flex flex-row align-items-center" >
                {isMobile ?
                  <p
                    className="form-control noselect text-center"
                    onClick={() => {
                      setShowPicker(true);
                      setDatePickerName('startDate')
                    }}>
                    {state.startDate
                      ? format(new Date(state.startDate), "yyyy/MM/dd")
                      : "از تاریخ"}
                  </p>

                  :
                  <DatePicker
                    inputClass='form-control '
                    containerStyle={{
                      width: "100%"
                    }}
                    editable={true}
                    calendar={persian}
                    locale={persian_fa}
                    onChange={(date) => {
                      console.log(date.unix * 1000)
                      // if (date)
                      setState(prevState => { return { ...prevState, startDate: new Date(date.unix * 1000) } })
                    }}
                    value={state?.startDate}
                    calendarPosition="bottom-left"
                  />
                }
              </div>
              <lable className="px-2">
                تا
              </lable>
              <div className="ps-1 d-flex flex-row align-items-center" >
                {isMobile ?
                  <p
                    className="form-control noselect text-center"
                    onClick={() => {
                      setShowPicker(true);
                      setDatePickerName('endDate')
                    }}>
                    {state.endDate
                      ? format(new Date(state.endDate), "yyyy/MM/dd")
                      : "تا تاریخ"}
                  </p>



                  :
                  <DatePicker
                    inputClass='form-control'
                    containerStyle={{
                      width: "100%"
                    }}
                    editable={true}
                    calendar={persian}
                    locale={persian_fa}
                    onChange={(date) => {
                      console.log(date.unix * 1000)
                      // if (date)
                      setState(prevState => { return { ...prevState, endDate: new Date(date.unix * 1000) } })
                    }}

                    value={state?.endDate}
                    calendarPosition="bottom-left"
                  />
                }
              </div>

            </div>
            : <></>}



      </div>
      <Tabs>
        <TabList>
          <Tab>در حال انجام</Tab>
          <Tab>اتمام یافته</Tab>
          <Tab>کنسل شده</Tab>
        </TabList>
        <div
          className="position-relative hideScrollBar"
          style={{ overflowY: "scroll", height: `${screenHight}px` }}
        >
          <TabPanel>
            <DoingService startDate={state.startDate} endDate={state.endDate} refreshPage={() => {
              setState(prevState => ({
                ...prevState
                , refresh: !state?.refresh
              }))
            }} />
          </TabPanel>

          <TabPanel>
            <FinsiehedService startDate={state.startDate} endDate={state.endDate} />
          </TabPanel>
          <TabPanel>
            <CanceledService startDate={state.startDate} endDate={state.endDate} />
          </TabPanel>
        </div>
      </Tabs>

      <Picker
        isOpen={showPicker}
        config={config}
        minDate={minDate}
        maxDate={maxDate}
        onSubmit={(selectedDate) => {
          var data = selectedDate.date;
          setState((prevState) => {
            return { ...prevState, [pickerName]: new Date(data.getTime()) };
          });
        }}
        onClose={() => setShowPicker(false)}
        highlightWeekends
      />
    </div>
  );
}
export default TrackingService;
